(function ($, dom, utils) {
	$(function () {
		var $topMenu = $('.topMenu'),
			$button = $('.topMenuButton'),
			$buttonBg = $('.topMenuButton__bg'),
			$items = $topMenu.find('.topMenuList__item'),
			width = $(window).width(),
			$header,
			size = width/$items.length;

		$button.on('click', function(){
			if ($topMenu.hasClass('open')) {
				app.utils.menuClose();
			} else {
				app.utils.menuOpen();
			};
		});

		function centeringButton() {
			if ($('.page').hasClass('main')) $header = $('.header__left');
			else $header = $('.header');

			var headerH = $header.height();
				buttonH = $button.height(),
				buttonBgH = $buttonBg.height();

			$button.css({
				top: (headerH/2) - (buttonH/2)
			});
			$buttonBg.css({
				top: (headerH/2) - (buttonBgH/2)
			});
		};

		centeringButton();
		$(window).on('resize', centeringButton);
	});
})(jQuery, app.dom, app.utils);
